module.exports = __webpack_public_path__ + "static/media/Intro to Human Rights.c5541225.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PHIL/Intro to Human Rights.pdf
// module id = 155
// module chunks = 0